import { connect } from "react-redux";

import { FacilityConfigurationMenu } from "./FacilityConfigurationMenu";

import type { State } from "../../reducers";

const mapStateToProps = (state: State) => ({
  facilities: state.facilities,
});

export const FacilityConfigurationMenuContainer =
  connect(mapStateToProps)(FacilityConfigurationMenu);
